import svg from './row-svg/telechargement.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function TelechargementIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default TelechargementIcon;
